import { createContext, useContext, type ReactNode } from 'react'

type SettingsLayoutContextValue = {
  drawerOpen: boolean
  setDrawerOpen: (open: boolean) => void
}

const SettingsLayoutContext = createContext<SettingsLayoutContextValue | null>(
  null,
)

export function SettingsLayoutProvider({
  drawerOpen,
  setDrawerOpen,
  children,
}: SettingsLayoutContextValue & { children: ReactNode }) {
  return (
    <SettingsLayoutContext.Provider value={{ drawerOpen, setDrawerOpen }}>
      {children}
    </SettingsLayoutContext.Provider>
  )
}

export function useSettingsLayout() {
  const context = useContext(SettingsLayoutContext)
  if (!context) {
    throw new Error('useSettingsLayout must be used within SettingsLayoutProvider')
  }
  return context
}
